import { measureEvent } from "./consent/runtime";

// Niente coda né invio prima del consenso: gli eventi precedenti non vengono recuperati.
export const track = (name, payload = {}) => {
    try {
        measureEvent(name, payload);
    } catch {}
};
